import React, { Fragment } from "react";
import { GetRailProps, GetHandleProps, GetTrackProps } from "react-compound-slider";

// *******************************************************
// RAIL
// *******************************************************
const railOuterStyle: React.CSSProperties = {
  position: "absolute",
  width: "100%",
  height: 3,
  cursor: "pointer",
};

const railInnerStyle: React.CSSProperties = {
  position: "absolute",
  width: "100%",
  height: 33,
  pointerEvents: "none",
  backgroundColor: "white",
};

type RailProps = {
  getRailProps: GetRailProps;
};

export function SliderRail({ getRailProps }: RailProps) {
  return (
    <Fragment>
      <div style={railOuterStyle} {...getRailProps()} />
      <div style={railInnerStyle} />
    </Fragment>
  );
}

// *******************************************************
// HANDLE COMPONENT
// *******************************************************

type HandleProps = {
  domain: [number, number];
  handle: { id: string; value: number; percent: number };
  disabled: boolean;
  getHandleProps: GetHandleProps;
  width: number;
};

export function Handle({
  domain: [min, max],
  handle: { id, value, percent },
  disabled,
  getHandleProps,
  width,
}: HandleProps) {

  return (
    <Fragment>
      <div
        style={{
          left: `calc(${percent}% - ${width / 2}px`,
          position: "absolute",
          WebkitTapHighlightColor: "rgba(0,0,0,0)",
          zIndex: 5,
          width: width,
          height: 32,
          cursor: "pointer",
          backgroundColor: "none",
        }}
        {...getHandleProps(id)}
      />
      <div
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        style={{
          left: `calc(${percent}% - ${width / 2}px`,
          position: "absolute",
          zIndex: 2,
          width: width,
          height: 32,
          borderRadius: "10px",
          backgroundColor: disabled ? "#666" : "#C4C4C4",
        }}
      />
    </Fragment>
  );
}

// *******************************************************
// KEYBOARD HANDLE COMPONENT
// Uses a button to allow keyboard events
// *******************************************************

type KeyboardHandleProps = {
  domain: [number, number];
  handle: { id: string; value: number; percent: number };
  disabled: boolean;
  getHandleProps: GetHandleProps;
};

export function KeyboardHandle({
  domain: [min, max],
  handle: { id, value, percent },
  disabled,
  getHandleProps,
}: KeyboardHandleProps) {
  return (
    <button
      role="slider"
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      style={{
        left: `${percent}%`,
        position: "absolute",
        transform: "translate(-50%, -50%)",
        zIndex: 2,
        width: 24,
        height: 24,
        borderRadius: "50%",
        boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.3)",
        backgroundColor: disabled ? "#666" : "#ffc400",
      }}
      {...getHandleProps(id)}
    />
  );
}

// *******************************************************
// TRACK COMPONENT
// *******************************************************
type TrackProps = {
  source: {
    id: string;
    value: number;
    percent: number;
  };
  target: {
    id: string;
    value: number;
    percent: number;
  };
  getTrackProps: GetTrackProps;
  disabled: boolean;
};
export function Track({ source, target, getTrackProps, disabled }: TrackProps) {
  return (
    <div
      style={{
        position: "absolute",
        //transform: 'translate(0%, -50%)',
        height: 33,
        zIndex: 1,
        backgroundColor: disabled ? "#999" : "gray",
        //borderRadius: 7,
        cursor: "pointer",
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
      }}
      {...getTrackProps()}
    />
  );
}

// *******************************************************
// TICK COMPONENT
// *******************************************************

type TickProps = {
  tick: {
    id: string;
    value: number;
    percent: number;
  };
  count: number;
  format: (value: number) => string;
};

export function Tick({ tick, count, format }: TickProps) {
  return (
    <div>
      <div
        style={{
          position: "absolute",
          marginTop: 14,
          width: 1,
          height: 5,
          backgroundColor: "rgb(200,200,200)",
          left: `${tick.percent}%`,
        }}
      />
      <div
        style={{
          position: "absolute",
          marginTop: 22,
          fontSize: 10,
          textAlign: "center",
          marginLeft: `${-(100 / count) / 2}%`,
          width: `${100 / count}%`,
          left: `${tick.percent}%`,
        }}
      >
        {format(tick.value)}
      </div>
    </div>
  );
}
